import styled from 'styled-components';

export const Warning = styled.span`
    color: red;
`;
